<div class="p-dialog-content-wrapper">
	<div class="spinner" *ngIf="loading">
		<p-progressSpinner
			strokeWidth="4"
			[style]="{ width: '40px', height: '40px' }"
		></p-progressSpinner>
	</div>

	<ng-container *ngIf="favorites$ | async as favorites">
		<div class="favorites__wrapper">
			<ul class="favorites__list">
				<li
					class="favorite__feedback"
					*ngIf="favorites.metadata.count <= 0; else favoritesList"
				>
					<small class="w-9 text-center">
						Você ainda não tem nenhum produto marcado como favorito.
					</small>
				</li>

				<ng-template #favoritesList>
					<li
						*ngFor="let item of favorites.result | slice: startSlice:endSlice"
					>
						<div
							class="favorite__item"
							routerLink="/product/{{
								item.product.parentId || item.productId
							}}"
							[queryParams]="{
								variation: item.product.parentId ? item.product.id : null
							}"
						>
							<div class="favorite__item__wrapper">
								<img
									*ngIf="
										item.product.pictures[0] as mainPicture;
										else defaultImage
									"
									class="favorite__image"
									[src]="mainPicture.url"
									[alt]="mainPicture.description"
									[style.object-fit]="objectFit"
								/>
								<ng-template #defaultImage>
									<div class="favorite__image" style="font-size: 0.3rem">
										<app-img-default></app-img-default>
									</div>
								</ng-template>

								<div class="favorite__content">
									<strong class="favorite__name">
										{{ item.product.name }}
									</strong>
									<small class="favorite__code">
										SKU: {{ item.product.sku }}
									</small>

									<ng-container *ngIf="item.product.prices.length">
										<div class="favorite__content_price">
											<small
												*ngIf="item.product.originalPrice"
												class="product__price__before"
											>
												De:
												<del>
													{{ item.product.originalPrice | currency: 'R$' }}
												</del>
											</small>
											<strong
												[class.promotional-price]="item.product.originalPrice"
												class="favorite__price"
											>
												<small *ngIf="item.product.originalPrice">Por: </small>
												{{ item.product.prices[0].price | currency: 'R$' }}
												{{ item.product.sellingUnit }}
											</strong>
										</div>
									</ng-container>
								</div>
							</div>
							<i class="fa-solid fa-chevron-right"></i>
						</div>
						<p-divider></p-divider>
					</li>
				</ng-template>
			</ul>
		</div>

		<ng-container *ngIf="favorites.metadata.totalItems as totalItems">
			<p-divider
				*ngIf="totalItems > endSlice"
				class="more__favorites"
				align="center"
			>
				<span *ngIf="totalItems - endSlice as moreItems">
					+{{ moreItems }} {{ moreItems === 1 ? 'item' : 'itens' }} na lista de
					favoritos
				</span>
			</p-divider>
		</ng-container>

		<div class="p-dialog-footer">
			<p-button
				*ngIf="(favorites.metadata.totalItems || 0) > 0"
				icon="fa-solid fa-heart"
				label="Ver todos os favoritos"
				(onClick)="openFavorites()"
			></p-button>
		</div>
	</ng-container>
</div>
